import {
  AbstractModalContent,
  RadioOption,
  Translate,
} from '@galigeo-store/ui-lib';
import { TemplateResult, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { GaligeoCloudService } from '../../services/galigeo-cloud.service';

@customElement('add-map-modal')
export class AddMapModalComponent extends AbstractModalContent {
  @property({ type: Object }) newMap: any = {};

  maps: any[] = [];

  static get styles() {
    return [
      ...super.styles,
      css`
        .add-input {
          width: 100%;
          margin-top: 20px;
          display: block;
        }
      `,
    ];
  }

  constructor() {
    super();
  }

  public async firstUpdated() {
    this.enableAddButton(false);
    this.maps = await GaligeoCloudService.getMaps();
  }

  private onTypeChange(event: CustomEvent) {
    this.newMap.type = event.detail;
    this.enableAddButton(this.nameIsValid(this.newMap.name));
    this.requestUpdate();
  }

  private onNameChange(event: CustomEvent) {
    this.newMap.name = event.detail;
    this.enableAddButton(this.nameIsValid(this.newMap.name));
  }

  private nameIsValid(name: string): boolean {
    if (!name || name.length < 2) {
      return false;
    }
    // Check if the name already exists in the maps
    return !this.maps.some(
      (map) => map.label.toLowerCase() === name.toLowerCase(),
    );
  }

  private onUrlChange(event: CustomEvent) {
    this.newMap.url = event.detail;
  }

  public render(): TemplateResult {
    const options: RadioOption[] = [
      { label: Translate.get('add_new_map'), value: 'map' },
      { label: Translate.get('add_new_app'), value: 'app' },
    ];
    return html`
      <div class="slds-grid slds-grid_vertical">
        <div class="slds-col">
          <ggo-radio-group
            .options="${options}"
            .selectedValue="${this.newMap.type || 'map'}"
            @changed="${this.onTypeChange}"
          ></ggo-radio-group>
        </div>
        <div class="slds-col">
          ${this.newMap.type === 'map'
            ? this.renderMapInput()
            : this.renderAppInput()}
        </div>
      </div>
    `;
  }

  renderMapInput(): TemplateResult {
    const placeholder = Translate.get('add_enter_map_name');
    return html`
      <ggo-text-input
        type="text"
        class="add-input"
        placeholder="${placeholder}"
        @text-input="${this.onNameChange}"
        value="${this.newMap.name || ''}"
      />
    `;
  }

  renderAppInput(): TemplateResult {
    return html` <div class="slds-form-element">
      <ggo-text-input
        class="add-input"
        placeholder="${Translate.get('add_enter_app_name')}"
        @text-input="${this.onNameChange}"
        value="${this.newMap.name || ''}"
      ></ggo-text-input>

      <ggo-text-input
        class="add-input"
        placeholder="${Translate.get('add_enter_app_url')}"
        @text-input="${this.onUrlChange}"
        value="${''}"
      ></ggo-text-input>
    </div>`;
  }
}
